import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../authentication/useAuth';

const AuthGuard = ({ children }) => {
    const { user, canView } = useAuth();
    const location = useLocation();

    // The API refuses an expired login and the app then signs out; checking expiry here as well
    // threw the user out of the password lock screen and lost their unsaved work
    if (!user) {
        return <Navigate to="/ims/login" state={{ from: location }} replace />;
    }
    const { pathname } = location;
    const [, , , pathModule] = pathname.split('/');
    if (pathModule && pathModule !== 'not-found') {
        if (!canView(pathModule)) {
            return <Navigate to="/ims/dashboard/not-found" />;
        }
    }

    return children;
};

export default AuthGuard;
